/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult {
  DidNotTryToCharge = "DidNotTryToCharge",
  ChargeSuccessful = "ChargeSuccessful",
  ChargeUnsuccessful = "ChargeUnsuccessful",
}

export function instanceOfInvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult(
  value: any,
): boolean {
  for (const key in InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult) {
    if (
      Object.prototype.hasOwnProperty.call(
        InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult,
        key,
      )
    ) {
      if (
        InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult[
          key as keyof typeof InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResultFromJSON(
  json: any,
): InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult {
  return InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResultFromJSONTyped(
    json,
    false,
  );
}

export function InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult {
  return json as InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult;
}

export function InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResultToJSON(
  value?: InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult | null,
): any {
  return value as any;
}

export function InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResultToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult {
  return value as InvoiceAndPotentiallyChargeCustomerForAdditionalChargeResult;
}
